import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { genOptionLoaderDebounced } from "../../../../../../_metronic/_helpers/fetchUtils";
import AsyikSelect from "react-select/async";
import { findOrganizationClassification } from "../../../_redux/organization-classification/organizationClassificationCrud";

export default function OrganizationActivatedModal({
  show,
  onHide,
  title,
  onClick,
  initialValues
}) {
  const [options, setOptions] = useState({
    org_classification: []
  });
  useEffect(() => {
    if (show) {
      findOrganizationClassification({
        pageNumber: 1,
        pageSize: 10,
        filter: {}
      }).then(res => {
        const {
          data: { data }
        } = res;
        setOptions(prev => ({
          ...prev,
          org_classification: data.items
        }));
      });
    }
  }, [show]);

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={values => onClick(values)}
      >
        {({
          setFieldValue,
          values,
          handleSubmit,
          handleChange,
          handleBlur
        }) => (
          <Modal
            size="md"
            show={show}
            centered
            onHide={onHide}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                {title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group row">
                <div className="col">
                  <label>
                    <strong>Masa Aktif Lembaga</strong>
                  </label>
                  <input
                    name="end_date"
                    type={"date"}
                    className="form-control"
                    placeholder="Masukan masa aktif mpz"
                    value={values.end_date}
                    onChange={e => {
                      const value = e.target.value || null;
                      setFieldValue(e.target.name, value);
                    }}
                  />
                </div>
              </div>
              <div className="form-group row">
                <div className="col">
                  <label>
                    <strong>Klasifikasi Lembaga</strong>
                  </label>
                  <AsyikSelect
                    defaultOptions={options.org_classification.map(
                      ({ name, uuid }) => ({ label: name, value: uuid })
                    )}
                    loadOptions={genOptionLoaderDebounced(
                      inputValue =>
                        findOrganizationClassification({
                          pageNumber: 1,
                          pageSize: 10,
                          filter: {
                            name: inputValue
                          }
                        }),
                      ({ uuid, name }) => ({ label: name, value: uuid })
                    )}
                    value={
                      values.organization_classification_uuid
                        ? {
                            label: values.organization_classification_name,
                            value: values.organization_classification_uuid
                          }
                        : null
                    }
                    placeholder="Pilih Klasifikasi Lembaga..."
                    onChange={selected => {
                      const { label = "", value = "" } = selected ?? {};

                      setFieldValue("organization_classification_name", label);
                      setFieldValue("organization_classification_uuid", value);
                    }}
                    isClearable
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div>
                <button
                  type="button"
                  onClick={onHide}
                  className="btn btn-light btn-elevate"
                >
                  Cancel
                </button>
                <> </>
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-primary btn-elevate"
                >
                  Yakin
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>
    </div>
  );
}
